module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cat-video cl-container"
  }, [(_vm.busy) ? [_vm._m(0), _vm._v(" "), _vm._m(1)] : _vm._l((_vm.recommendVideoLectures), function(item, index) {
    return _c('TextCard', {
      key: index,
      attrs: {
        "videoLecture": item,
        "isList": true
      }
    })
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dummy-card"
  }, [_c('div', {
    staticClass: "dummy-card-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "dummy-card-text"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dcc5825c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/cat-main/components/VideoLecture.vue
// module id = 1613
// module chunks = 1